// @flow

// colors
export const oedu_white = '#fff'
export const oedu_green = '#2fc25b'
export const oedu_red = '#f04864'
export const oedu_text = 'rgba(0,0,0,.65)'



// WEBPACK FOOTER //
// ./src/styles/base.js